module.exports = __webpack_public_path__ + "img/hero.8775f152.png";